import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

 // public accessRight = AccessRights;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url.substr(1);
 //   const currentUser = this.authenticationService.currentUserValue;

    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0];
    }
    // if (currentUser != null) {
    //   if (currentUser.userMenu.indexOf(url) !== -1) {
    //     const userRights = this.authenticationService.currentUserRights(url);

    // //    this.accessRight.isAdd = userRights.isadd;
    //     this.accessRight.isEdit = userRights.isedit;
    //     this.accessRight.isDelete = userRights.isdelete;
    //     // if (currentUser) {
    //     // logged in so return true
    //     return true;
    //   }

    //   // not logged in so redirect to login page with the return url
    //   this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //   return false;
    // }
    else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}

